import React from 'react';
import { Button, withTheme } from '@rneui/themed';
import { FAIcon } from '../elements';
export const UnthemedOptionButton = ({ containerStyle = {}, iconStyle = {}, iconName = 'ellipsis-v', customIcon, onShowOptions, }) => {
    return (React.createElement(React.Fragment, null,
        React.createElement(Button, { onPress: onShowOptions, containerStyle: containerStyle }, customIcon ? (React.createElement(React.Fragment, null, customIcon)) : (React.createElement(FAIcon, { name: iconName, style: iconStyle })))));
};
export const OptionButton = withTheme(UnthemedOptionButton, 'OptionButton');
//# sourceMappingURL=OptionButton.js.map